import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import { IItemCardProps } from 'models/itemcard';
import * as moment from 'moment';
import { IComment, IUserMentionsDataItem, IKeyValuePair } from 'models/common';
import { StarsRating } from '../../../Common/StarsRating';

require('./style.css');

interface IProps extends IItemCardProps {
	item: IComment;
	t?: (key: string, options?: any) => string;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class CommentItemCard extends React.Component<IProps, any> {
	private userIds: IKeyValuePair[];

	constructor(props) {
		super(props);

		this.userIds = [];

		this.formatMentionText = this.formatMentionText.bind(this);
		this.goToCard = this.goToCard.bind(this);
	}

	private goToCard(e, i) {
		e.preventDefault();
		if (this.props.goToCard) {
			this.props.goToCard(this.userIds.find((userId) => userId.key === i).value);
		}
	}

	private formatMentionText(text, values, regex, dataArray: IUserMentionsDataItem[]) {
		if (!values.length) {
			return text;
		}

		let index: number = 0;

		return (
			<div>
				{text.split(regex).reduce((prev, current, i) => {
					if (!i) {
						return [current];
					}

					let element;

					if (values.includes(current)) {
						element = (
							<a
								href="#"
								key={i}
								onClick={(e) => {
									this.goToCard(e, i);
								}}
							>
								@{dataArray[index].name}
							</a>
						);
						if (!this.userIds.find((item) => item.key === i)) {
							this.userIds.push({ key: i, value: dataArray[index].id });
						}
						index++;
					} else {
						element = current;
					}

					return prev.concat(element);
				}, [])}
			</div>
		);
	}

	public render() {
		const { body, addedBy, addedByPicture, addedDate, data, rating } = this.props.item;

		let picture = addedByPicture;
		if (!picture) {
			picture = require('containers/Html/images/defaultUser.svg');
		}

		const dataArray = JSON.parse(data);
		const values = dataArray.map((item) => {
			return item.name;
		});
		const regex = new RegExp(/\[usermention:(.*?)\]/);

		return (
			<div className="commentItemCard">
				{rating ? (
					<div className="rating">
						<StarsRating editing={false} rating={rating} hideRatingNumber={true} />
					</div>
				) : null}
				<div className="commentText">{this.formatMentionText(body, values, regex, dataArray)}</div>
				<div>
					<div className="wrapperBottomImg">
						<span className="imageUserIcon">{addedBy.substring(0, 1)}</span>
						<span className="dateUser">
							{addedBy}, {moment.utc(addedDate).fromNow()}
						</span>
					</div>
				</div>
			</div>
		);
	}
}

export { CommentItemCard };
